/*-----------------------------------------------------------------------------------
 Template Name: Admiro
 Template URI: themes.pixelstrap.com/Admiro
 Description: This is Admin Template
 Author: Pixelstrap
 Author URI: https://themeforest.net/user/pixelstrap
 ----------------------------------------------------------------------------------- */
// 01. Loader js
// 02. Tap to top js
// 03. Header DropDown Toggle js
// 04. Full screen js
document.addEventListener("DOMContentLoaded", function () {
    const body = document.querySelector("body");
    const html = document.querySelector("html");
    /*=====================
        01 Loader Js
    ==========================*/
    $(".loader-wrapper").css({
        opacity: 0,
        transition: "opacity 600ms ease"
    });

    setTimeout(() => {
        $(".loader-wrapper").remove();
    }, 600);
    /*=====================
          02 Tap to top js
      ==========================*/
    const button = document.querySelector(".tap-top");
    const displayButton = () => {
        window.addEventListener("scroll", () => {
            if (window.scrollY > 100) {
                button.style.display = "block";
            } else {
                button.style.display = "none";
            }
        });
    };
    const scrollToTop = () => {
        button.addEventListener("click", () => {
            window.scroll({
                top: 0,
                left: 0,
                behavior: "smooth",
            });
            console.log(event);
        });
    };
    displayButton();
    scrollToTop();
    /*=====================
        03 Header DropDown Toggle
    ==========================*/
    body.addEventListener("click", function (event) {
        const headerDropdownMenu = document.querySelectorAll(".custom-menu");
        const dropdownEl = event.target.closest(".custom-dropdown");
        const visible = dropdownEl
            ?.querySelector(".custom-menu")
            .classList.contains("show");
        const dropdownMenuElement = event.target.closest(".custom-menu");
        if (!dropdownMenuElement) {
            headerDropdownMenu.forEach((item) => {
                item.classList.remove("show");
            });
        }
        if (!dropdownEl) return;
        const dropdownMenu = dropdownEl.querySelector(".custom-menu");
        if (!visible) dropdownMenu.classList.add("show");
    });
    /*=====================
        04 Full screen js
    ==========================*/
    $(document).ready(function () {
        $(".full-screen").click(function (event) {
            var elem = document.documentElement;

            if (
                (document.fullScreenElement && document.fullScreenElement !== null) ||
                (!document.mozFullScreen && !document.webkitIsFullScreen)
            ) {
                if (elem.requestFullScreen) {
                    elem.requestFullScreen();
                } else if (elem.mozRequestFullScreen) {
                    elem.mozRequestFullScreen();
                } else if (elem.webkitRequestFullScreen) {
                    elem.webkitRequestFullScreen(Element.ALLOW_KEYBOARD_INPUT);
                }
            } else {
                if (document.cancelFullScreen) {
                    document.cancelFullScreen();
                } else if (document.mozCancelFullScreen) {
                    document.mozCancelFullScreen();
                } else if (document.webkitCancelFullScreen) {
                    document.webkitCancelFullScreen();
                }
            }
        });
    });

    /*=====================
         05. Dark Mode js
      ==========================*/
    $(".dark-mode").on("click", function () {
        const bodyModeDark = $("body").hasClass("dark-only");

        if (!bodyModeDark) {
            // Activate dark mode
            $(".dark-mode").addClass("active");
            localStorage.setItem("mode", "dark-only");
            $("body").addClass("dark-only");
            $("body").removeClass("light");

            // Switch to dark logo
            $(".light-logo").hide();
            $(".dark-logo").show();
        } else {
            // Activate light mode
            $(".dark-mode").removeClass("active");
            localStorage.setItem("mode", "light");
            $("body").removeClass("dark-only");
            $("body").addClass("light");

            // Switch to light logo
            $(".dark-logo").hide();
            $(".light-logo").show();
        }
    });

// Apply the saved mode and logo when the page loads
    $(document).ready(function () {
        const mode = localStorage.getItem("mode") ? localStorage.getItem("mode") : "light";
        $("body").addClass(mode);

        if (mode === "dark-only") {
            $(".light-logo").hide();
            $(".dark-logo").show();
        } else {
            $(".dark-logo").hide();
            $(".light-logo").show();
        }
    });


    /*=====================
      00. Background Image js
      ==========================*/
    $(".bg-center").parent().addClass("b-center");
    $(".bg-img-cover").parent().addClass("bg-size");
    $(".bg-img-cover").each(function () {
        var el = $(this),
            src = el.attr("src"),
            parent = el.parent();
        parent.css({
            "background-image": "url(" + src + ")",
            "background-size": "cover",
            "background-position": "center",
            display: "block",
        });
        el.hide();
    });
});
